{
  "noAssignedModeling": "Kein Projekt ausgewählt",
  "modelings": "Projekte",
  "pleaseSignIn": "Bitte anmelden",
  "email": "Email",
  "enterLogin": "Eingabe Benutzername",
  "signIn": "anmelden",
  "password": "Passwort",
  "enterPassword": "Eingabe Passwort",
  "filterByName": "Filter nach Name",
  "settings": "Einstellungen",
  "logout": "Logout",
  "home": "Übersicht",
  "users": "Nutzer",
  "areas": "Gebiete",
  "modelingName": "Projektname",
  "passwordChange": "Passwort ändern",
  "close": "Schließen",
  "confirm": "Bestätigen",
  "userDelete": "Nutzer löschen",
  "wannaDeleteThisUser": "Wollen Sie den Nutzer löschen?",
  "delete": "Löschen",
  "userCreation": "Nutzer anlegen",
  "create": "Anlegen",
  "name": "Name",
  "enterUserName": "Eingabe Benutzername",
  "loginName": "Benutzername",
  "role": "Rolle",
  "chooseRole": "Rolle auswählen",
  "projectadmin": "Projekt Admin",
  "viewer": "Betrachter",
  "admin": "Admin",
  "team": "Team",
  "teamName": "Teambezeichnung",
  "group": "Gruppe",
  "groups": "Gruppen",
  "chooseGroup": "Gruppe auswählen",
  "choose": "Auswählen",
  "groupCreation": "Gruppe anlegen",
  "enterGroupName": "Eingabe Gruppenbezeichnung",
  "groupDetail": "Gruppe Details",
  "save": "Speichern",
  "userDetail": "Nutzer Details",
  "string": "Text",
  "integer": "Ganzzahl",
  "decimal": "Dezimalzahl",
  "dateTime": "Datum/Uhrzeit",
  "boolean": "Wahr/Falsch (Boolean)",
  "column": "Spalte",
  "dataType": "Datentyp",
  "row": "Zeile",
  "tableName": "Tabellenname",
  "import": "Import",
  "dataSpaces": "Projekte",
  "noAssignedDataSpace": "Kein Projekt ausgewählt",
  "dataspaces": "Projekte",
  "dataSpaceName": "Projektname",
  "dataSpaceCreation": "Projekt anlegen",
  "dataSpaceDetail": "Projekt Details",
  "wannaDeleteThisDataSpace": "Wollen Sie das Projekt löschen?",
  "dataSpaceDelete": "Projekt löschen",
  "allDataWillBeLost": "Alle Daten werden gelöscht",
  "tables": "Tabellen",
  "batches": "Prozesse",
  "tablesInDataSpace": "Tabellen in Projekt",
  "batchesInDataSpace": "Prozesse in Projekt",
  "searchTable": "Tabellensuche",
  "noTables": "Keine Tabelle",
  "tableDetail": "Tabellen Details",
  "structure": "Struktur",
  "dataPreview": "Daten Vorschau",
  "noData": "Keine Daten",
  "confirmDeleteTable": "Bestätigung Tabelle löschen",
  "importCsv": "Import CSV",
  "file": "Datei",
  "delimiter": "Trennzeichen",
  "semicolon": "Strichpunkt",
  "comma": "Komma",
  "tab": "Tab",
  "columns": "Spalten",
  "importing": "Importieren",
  "newBatch": "Neuer Prozess",
  "editBatch": "Prozess bearbeiten",
  "noBatches": "Keine Prozesse",
  "confirmDeleteBatch": "Bestätigung Prozess löschen",
  "batchName": "Prozessname",
  "batchNamePlaceholder": "Platzhalter Prozessname",
  "createBatch": "Prozess anlegen",
  "batchType": "Prozesstyp",
  "dataLoadMethod": "Prozesstyp",
  "typeCopy": "Datentransfer",
  "typeCopyDesc": "Abschnitte vorhanden, Datenspalten werden erzeugt",
  "typeAggregation": "Datengruppierung",
  "typeAggregationDesc": "Datenaggregierung zu definierten Gruppen",
  "typeCsd": "KGN",
  "typeCsdDesc": "Abschnittsbildung durch Kleinstes Gemeinsames Nenner Verfahren",
  "output": "Ausgabe",
  "input": "Eingabe",
  "inputs": "Eingaben",
  "transformation": "Transformation",
  "copy": "Kopie",
  "aggregation": "Datengruppierung",
  "inputTable": "Eingangstabelle",
  "outputTable": "Ergebnistabelle",
  "outputTableName": "Name Ergebnistabelle",
  "selectTable": "Tabelle wählen",
  "outputIdName": "Ergebnistabelle Spalte ID",
  "outputFromName": "Ergebnistabelle Spalte Von",
  "outputToName": "Ergebnistabelle Spalte Bis",
  "inputIdName": "Eingangstabelle Spalte ID",
  "inputFromName": "Eingangstabelle Spalte Von",
  "inputToName": "Eingangstabelle Spalte Bis",
  "includeColumns": "Auswahl Spalten",
  "addColumn": "Spalte hinzufügen",
  "alias": "Alias",
  "function": "Typ",
  "selectFunction": "Auswahl Typ",
  "groupBy": "Gruppierung nach",
  "aggregateColumns": "Spalten Gruppe",
  "transformationSteps": "Transformationsschritte",
  "stepTable": "Schritt Tabelle",
  "stepColumns": "Schritt Spalten",
  "addStep": "Schritt hinzufügen",
  "addInput": "Eingabe hinzufügen",
  "addTable": "Tabelle hinzufügen",
  "expressions": "Formeln",
  "expression": "Formel",
  "addExpression": "Formel hinzufügen",
  "expressionPlaceholder": "Platzhalter Formel",
  "moveUp": "hinauf",
  "moveDown": "hinunter",
  "run": "Ausführen",
  "runDataBatch": "Prozess ausführen",
  "areYouSureYouWantToRunThisDataBatch": "Wollen Sie den Prozess ausführen?",
  "running": "Wird ausgeführt",
  "batchRunSuccessful": "Prozess erfolgreich ausgeführt",
  "batchRunUnsuccessful": "Prozess NICHT erfolgreich ausgeführt",
  "tableAlreadyExists": "Tabelle existiert bereits",
  "unknownError": "Unbekannter Fehler",
  "type": "Typ",
  "status": "Status",
  "origin": "Ursprung",
  "source": "Quelle",
  "rows": "Zeilen",
  "size": "Größe",
  "created": "Erstellt",
  "cancel": "Abbrechen",
  "edit": "Bearbeiten",
  "back": "Zurück",
  "continue": "Fortsetzen",
  "loading": "Laden",
  "lastRun": "Letzte Ausführung",
  "duration": "Dauer",
  "saveAndRun": "Speichern und ausführen",
  "addGroupBy": "Gruppierung hinzufügen",
  "transformations": "Transformationen",
  "transformationTable": "Transformationstabelle",
  "addTransformation": "Transformation hinzufügen",
  "creationType": "Typ",
  "createdBy": "Erstellt von",
  "createdDate": "Datum",
  "export": "Export",
  "detail": "Detail"
}
